import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ModuloModule.css';

interface Modulo {
  cd_modulo: number;
  nm_modulo: string;
  ds_modulo?: string;
  rota_modulo: string;
  cd_ativo: number;
}

// Lista de identificadores de módulos disponíveis (baseado nas pastas do frontend)
const rotasDisponiveis = [
  { rota: 'cadastro', nome: 'Cadastro' },
  { rota: 'diario', nome: 'Diário de Bordo' },
  { rota: 'patio', nome: 'Pátio' },
  { rota: 'abastecimento', nome: 'Abastecimento' },
  { rota: 'manutencao', nome: 'Manutenção' },
  { rota: 'monitoramento', nome: 'Monitoramento' },
  { rota: 'levantamentoPosicoes', nome: 'Levantamento Posições' },
  { rota: 'etlBis', nome: 'ETL BIs' },
  { rota: 'powerbi', nome: 'Power BI' },
  { rota: 'programacao', nome: 'Programação' },
  { rota: 'seguranca', nome: 'Segurança' },
  { rota: 'suporte', nome: 'Suporte' },
  { rota: 'rh', nome: 'Rh' },
  { rota: 'apis', nome: 'APis' },
];

const ModuloModule: React.FC = () => {
  const [modulos, setModulos] = useState<Modulo[]>([]);
  const [form, setForm] = useState<Omit<Modulo, 'cd_modulo'>>({ nm_modulo: '', ds_modulo: '', rota_modulo: '', cd_ativo: 1 });
  const [editId, setEditId] = useState<number | null>(null);

  useEffect(() => {
    fetchModulos();
  }, []);

  const fetchModulos = async () => {
    const res = await axios.get<Modulo[]>('/api/modulos');
    setModulos(res.data);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`/api/modulos/${editId}`, form);
    } else {
      await axios.post('/api/modulos', form);
    }
    setForm({ nm_modulo: '', ds_modulo: '', rota_modulo: '', cd_ativo: 1 });
    setEditId(null);
    fetchModulos();
  };

  const handleEdit = (modulo: Modulo) => {
    setForm({ nm_modulo: modulo.nm_modulo, ds_modulo: modulo.ds_modulo || '', rota_modulo: modulo.rota_modulo, cd_ativo: modulo.cd_ativo });
    setEditId(modulo.cd_modulo);
  };

  const handleDelete = async (id: number) => {
    await axios.delete(`/api/modulos/${id}`);
    fetchModulos();
  };

  return (
    <div className="modulo-module">
      <h2>Cadastro de Módulos</h2>
      <form onSubmit={handleSubmit} className="modulo-form">
        <input name="nm_modulo" value={form.nm_modulo} onChange={handleChange} placeholder="Nome do módulo" required />
        <input name="ds_modulo" value={form.ds_modulo} onChange={handleChange} placeholder="Descrição" />
        <select name="rota_modulo" value={form.rota_modulo} onChange={handleChange} required>
          <option value="">Selecione o identificador do módulo</option>
          {rotasDisponiveis.map((rota) => (
            <option key={rota.rota} value={rota.rota}>{rota.nome} ({rota.rota})</option>
          ))}
        </select>
        <input name="cd_ativo" value={form.cd_ativo} onChange={handleChange} placeholder="Ativo (1/0)" type="number" min="0" max="1" />
        <button type="submit">{editId ? 'Atualizar' : 'Cadastrar'}</button>
        {editId && <button type="button" onClick={() => { setEditId(null); setForm({ nm_modulo: '', ds_modulo: '', rota_modulo: '', cd_ativo: 1 }); }}>Cancelar</button>}
      </form>
      <table className="modulo-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th>Descrição</th>
            <th>Identificador</th>
            <th>Ativo</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {modulos.map((modulo) => (
            <tr key={modulo.cd_modulo}>
              <td>{modulo.cd_modulo}</td>
              <td>{modulo.nm_modulo}</td>
              <td>{modulo.ds_modulo}</td>
              <td>{modulo.rota_modulo}</td>
              <td>{modulo.cd_ativo}</td>
              <td>
                <button onClick={() => handleEdit(modulo)}>Editar</button>
                <button onClick={() => handleDelete(modulo.cd_modulo)}>Excluir</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ModuloModule;
